{
  "_meta": {
    "description": "Stripped runtime subset of product-registry.json — generated by services/dtac/scripts/build-product-registry-lite.mjs",
    "generatedAt": "2026-04-20T05:25:07.420Z",
    "sourceFile": "product-registry.json"
  },
  "products": {
    "marketplace": {
      "resourceOwner": "marketplace",
      "displayName": "Marketplace",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "platform": {
      "resourceOwner": "platform",
      "displayName": "Platform",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "platform-services": {
      "resourceOwner": "platform-services",
      "displayName": "Platform Services",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "maker-space": {
      "resourceOwner": "maker-space",
      "displayName": "Forge",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "ecosystem": {
      "resourceOwner": "ecosystem",
      "displayName": "Ecosystem",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "media": {
      "resourceOwner": "media",
      "displayName": "Media",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "identity": {
      "resourceOwner": "identity",
      "displayName": "Identity",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "search": {
      "resourceOwner": "search",
      "displayName": "Search",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "loom": {
      "resourceOwner": "loom",
      "displayName": "Loom",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "confluence": {
      "resourceOwner": "confluence",
      "displayName": "Confluence",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira": {
      "resourceOwner": "jira",
      "displayName": "Jira",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-software": {
      "resourceOwner": "jira-software",
      "displayName": "Jira Software",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-core": {
      "resourceOwner": "jira-core",
      "displayName": "Jira Work Management",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-servicedesk": {
      "resourceOwner": "jira-servicedesk",
      "displayName": "Jira Service Management",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-customer-service": {
      "resourceOwner": "jira-customer-service",
      "displayName": "Jira Customer Service",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "cmdb": {
      "resourceOwner": "cmdb",
      "displayName": "Assets",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "conversational-help": {
      "resourceOwner": "conversational-help",
      "displayName": "Conversational Help",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "bitbucket": {
      "resourceOwner": "bitbucket",
      "displayName": "Bitbucket",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "trello": {
      "resourceOwner": "trello",
      "displayName": "Trello",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "avocado": {
      "resourceOwner": "avocado",
      "displayName": "Admin",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "passionfruit": {
      "resourceOwner": "passionfruit",
      "displayName": "Guard",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "atlashub": {
      "resourceOwner": "atlashub",
      "displayName": "Atlassian Hub",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "compass": {
      "resourceOwner": "compass",
      "displayName": "Compass",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "townsquare": {
      "resourceOwner": "townsquare",
      "displayName": "Home",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "opsgenie": {
      "resourceOwner": "opsgenie",
      "displayName": "Opsgenie",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "capacity-planning": {
      "resourceOwner": "capacity-planning",
      "displayName": "Capacity Planning",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "intelligent-routing": {
      "resourceOwner": "intelligent-routing",
      "displayName": "Intelligent Routing",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "statuspage": {
      "resourceOwner": "statuspage",
      "displayName": "Statuspage",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "analytics": {
      "resourceOwner": "analytics",
      "displayName": "Analytics",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "measurement": {
      "resourceOwner": "measurement",
      "displayName": "Measurement",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "teams": {
      "resourceOwner": "teams",
      "displayName": "Teams",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "commerce": {
      "resourceOwner": "commerce",
      "displayName": "Commerce",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "devops": {
      "resourceOwner": "devops",
      "displayName": "DevOps",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "graph": {
      "resourceOwner": "graph",
      "displayName": "External",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "runtime-auth-client": {
      "resourceOwner": "runtime-auth-client",
      "displayName": "Runtime Auth Client",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "avp": {
      "resourceOwner": "avp",
      "displayName": "Avp",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "linking-platform": {
      "resourceOwner": "linking-platform",
      "displayName": "Linking Platform",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "marketing": {
      "resourceOwner": "marketing",
      "displayName": "Marketing",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "data-lake": {
      "resourceOwner": "data-lake",
      "displayName": "Data Lake",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "exus-external": {
      "resourceOwner": "exus-external",
      "displayName": "Exus External",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "canvas": {
      "resourceOwner": "canvas",
      "displayName": "Canvas",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "canva.canva": {
      "resourceOwner": "canva.canva",
      "displayName": "Canva",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "automation": {
      "resourceOwner": "automation",
      "displayName": "Automation",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "elements": {
      "resourceOwner": "elements",
      "displayName": "Elements",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "help": {
      "resourceOwner": "help",
      "displayName": "Help",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "oauth": {
      "resourceOwner": "oauth",
      "displayName": "Oauth",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "mercury": {
      "resourceOwner": "mercury",
      "displayName": "Mercury",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "unified-help": {
      "resourceOwner": "unified-help",
      "displayName": "Help Center",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "virtual-agent": {
      "resourceOwner": "virtual-agent",
      "displayName": "Virtual Agent",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "beacon": {
      "resourceOwner": "beacon",
      "displayName": "Beacon",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "brie": {
      "resourceOwner": "brie",
      "displayName": "Brie",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "mapi": {
      "resourceOwner": "mapi",
      "displayName": "Mapi",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "papi": {
      "resourceOwner": "papi",
      "displayName": "Papi",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "approval-desk": {
      "resourceOwner": "approval-desk",
      "displayName": "Approval Desk",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "people-perftool": {
      "resourceOwner": "people-perftool",
      "displayName": "People Perftool",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-align": {
      "resourceOwner": "jira-align",
      "displayName": "Jira Align",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "support": {
      "resourceOwner": "support",
      "displayName": "Support",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "pollinator": {
      "resourceOwner": "pollinator",
      "displayName": "Pollinator",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "unified-portable-profile": {
      "resourceOwner": "unified-portable-profile",
      "displayName": "Unified Portable Profile",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "learning-platform": {
      "resourceOwner": "learning-platform",
      "displayName": "Learning Platform",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "google": {
      "resourceOwner": "google",
      "displayName": "Google",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "figma": {
      "resourceOwner": "figma",
      "displayName": "Figma",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "post-office": {
      "resourceOwner": "post-office",
      "displayName": "Post Office",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "microsoft": {
      "resourceOwner": "microsoft",
      "displayName": "Microsoft",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "dropbox": {
      "resourceOwner": "dropbox",
      "displayName": "Dropbox",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "dropbox.dropbox": {
      "resourceOwner": "dropbox.dropbox",
      "displayName": "Dropbox",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "docusign.docusign": {
      "resourceOwner": "docusign.docusign",
      "displayName": "DocuSign",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "cisco.webex": {
      "resourceOwner": "cisco.webex",
      "displayName": "Webex",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "mural.mural": {
      "resourceOwner": "mural.mural",
      "displayName": "Mural",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "airtable.airtable": {
      "resourceOwner": "airtable.airtable",
      "displayName": "Airtable",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "asana.asana": {
      "resourceOwner": "asana.asana",
      "displayName": "Asana",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "box.box": {
      "resourceOwner": "box.box",
      "displayName": "Box",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "gitlab.gitlab": {
      "resourceOwner": "gitlab.gitlab",
      "displayName": "GitLab",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "lucid.lucidchart": {
      "resourceOwner": "lucid.lucidchart",
      "displayName": "Lucidchart",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "miro.miro": {
      "resourceOwner": "miro.miro",
      "displayName": "Miro",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "monday.monday": {
      "resourceOwner": "monday.monday",
      "displayName": "Monday.com",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "notion.notion": {
      "resourceOwner": "notion.notion",
      "displayName": "Notion",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "servicenow.servicenow": {
      "resourceOwner": "servicenow.servicenow",
      "displayName": "ServiceNow",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "smartsheet.smartsheet": {
      "resourceOwner": "smartsheet.smartsheet",
      "displayName": "Smartsheet",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "zendesk.zendesk": {
      "resourceOwner": "zendesk.zendesk",
      "displayName": "Zendesk",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "slack": {
      "resourceOwner": "slack",
      "displayName": "Slack",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "org-policy": {
      "resourceOwner": "org-policy",
      "displayName": "Org Policy",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "people-data": {
      "resourceOwner": "people-data",
      "displayName": "People Data",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "workato": {
      "resourceOwner": "workato",
      "displayName": "Workato",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "workday": {
      "resourceOwner": "workday",
      "displayName": "Workday",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "connection-registry": {
      "resourceOwner": "connection-registry",
      "displayName": "Connection Registry",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "rovo": {
      "resourceOwner": "rovo",
      "displayName": "Rovo",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "convo-ai": {
      "resourceOwner": "convo-ai",
      "displayName": "Rovo Chat",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "css-xp": {
      "resourceOwner": "css-xp",
      "displayName": "Css Xp",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "goal": {
      "resourceOwner": "goal",
      "displayName": "Goals",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "project": {
      "resourceOwner": "project",
      "displayName": "Projects",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "devai": {
      "resourceOwner": "devai",
      "displayName": "Devai",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "proforma": {
      "resourceOwner": "proforma",
      "displayName": "ProForma",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "radar": {
      "resourceOwner": "radar",
      "displayName": "Radar",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "confluence-dc": {
      "resourceOwner": "confluence-dc",
      "displayName": "Confluence Dc",
      "isThirdParty": false,
      "platform": "third-party"
    },
    "pure": {
      "resourceOwner": "pure",
      "displayName": "Guard Premium",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "audit-log": {
      "resourceOwner": "audit-log",
      "displayName": "Audit Log",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "figma.figma": {
      "resourceOwner": "figma.figma",
      "displayName": "Figma",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "google.gmail": {
      "resourceOwner": "google.gmail",
      "displayName": "Gmail",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "google.google-calendar": {
      "resourceOwner": "google.google-calendar",
      "displayName": "Google Calendar",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "google.google-drive": {
      "resourceOwner": "google.google-drive",
      "displayName": "Google Drive",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "slack.slack": {
      "resourceOwner": "slack.slack",
      "displayName": "Slack",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "confluence-dc.confluence-dc": {
      "resourceOwner": "confluence-dc.confluence-dc",
      "displayName": "Confluence (Data Center)",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "jira-dc.jira-dc": {
      "resourceOwner": "jira-dc.jira-dc",
      "displayName": "Jira (Data Center)",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.azure-devops": {
      "resourceOwner": "microsoft.azure-devops",
      "displayName": "Azure DevOps",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.onedrive": {
      "resourceOwner": "microsoft.onedrive",
      "displayName": "OneDrive",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.outlook-calendar": {
      "resourceOwner": "microsoft.outlook-calendar",
      "displayName": "Outlook Calendar",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.power-bi": {
      "resourceOwner": "microsoft.power-bi",
      "displayName": "Power BI",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "clickup.clickup": {
      "resourceOwner": "clickup.clickup",
      "displayName": "ClickUp",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "amplitude.amplitude": {
      "resourceOwner": "amplitude.amplitude",
      "displayName": "Amplitude",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "adobe.adobexd": {
      "resourceOwner": "adobe.adobexd",
      "displayName": "Adobe XD",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "adobe.sign": {
      "resourceOwner": "adobe.sign",
      "displayName": "Adobe Sign",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "stripe.stripe": {
      "resourceOwner": "stripe.stripe",
      "displayName": "Stripe",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "dovetail.dovetail": {
      "resourceOwner": "dovetail.dovetail",
      "displayName": "Dovetail",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "login-alerter": {
      "resourceOwner": "login-alerter",
      "displayName": "Login Alerter",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "pipedrive.pipedrive": {
      "resourceOwner": "pipedrive.pipedrive",
      "displayName": "Pipedrive",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "zeplin.zeplin": {
      "resourceOwner": "zeplin.zeplin",
      "displayName": "Zeplin",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "github.github": {
      "resourceOwner": "github.github",
      "displayName": "GitHub",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "pagerduty.pagerduty": {
      "resourceOwner": "pagerduty.pagerduty",
      "displayName": "PagerDuty",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "todoist.todoist": {
      "resourceOwner": "todoist.todoist",
      "displayName": "Todoist",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "atlassian-web-crawler.atlassian-web-crawler": {
      "resourceOwner": "atlassian-web-crawler.atlassian-web-crawler",
      "displayName": "Web Crawler",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "salesforce.salesforce": {
      "resourceOwner": "salesforce.salesforce",
      "displayName": "Salesforce",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.teams": {
      "resourceOwner": "microsoft.teams",
      "displayName": "Microsoft Teams",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.outlook": {
      "resourceOwner": "microsoft.outlook",
      "displayName": "Outlook",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "hubspot.hubspot": {
      "resourceOwner": "hubspot.hubspot",
      "displayName": "HubSpot",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "hris-aws.hris-aws": {
      "resourceOwner": "hris-aws.hris-aws",
      "displayName": "AWS HRIS",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "microsoft.sharepoint": {
      "resourceOwner": "microsoft.sharepoint",
      "displayName": "SharePoint",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "launchdarkly.launchdarkly": {
      "resourceOwner": "launchdarkly.launchdarkly",
      "displayName": "LaunchDarkly",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "spinnaker.spinnaker": {
      "resourceOwner": "spinnaker.spinnaker",
      "displayName": "Spinnaker",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "settings-service": {
      "resourceOwner": "settings-service",
      "displayName": "Settings Service",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "sentry.sentry": {
      "resourceOwner": "sentry.sentry",
      "displayName": "Sentry",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "workday.workday": {
      "resourceOwner": "workday.workday",
      "displayName": "Workday",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "ml-registry": {
      "resourceOwner": "ml-registry",
      "displayName": "Ml Registry",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "trust-eng": {
      "resourceOwner": "trust-eng",
      "displayName": "Trust Eng",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "aha.aha": {
      "resourceOwner": "aha.aha",
      "displayName": "Aha!",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "migration-report-center": {
      "resourceOwner": "migration-report-center",
      "displayName": "Migration Report Center",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "elevate": {
      "resourceOwner": "elevate",
      "displayName": "Elevate",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "app-migration": {
      "resourceOwner": "app-migration",
      "displayName": "App Migration",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "cia": {
      "resourceOwner": "cia",
      "displayName": "Cia",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "home": {
      "resourceOwner": "home",
      "displayName": "Home",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "loom.loom": {
      "resourceOwner": "loom.loom",
      "displayName": "Loom",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "sandbox-service": {
      "resourceOwner": "sandbox-service",
      "displayName": "Sandbox Service",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "knowledge-discovery": {
      "resourceOwner": "knowledge-discovery",
      "displayName": "Knowledge Discovery",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "knowledge-serving-and-access": {
      "resourceOwner": "knowledge-serving-and-access",
      "displayName": "Knowledge Access",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-ai-crocs": {
      "resourceOwner": "jira-ai-crocs",
      "displayName": "Jira Ai Crocs",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "azure-devops.azure-devops": {
      "resourceOwner": "azure-devops.azure-devops",
      "displayName": "Azure DevOps",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "jsm-channel-orchestrator": {
      "resourceOwner": "jsm-channel-orchestrator",
      "displayName": "Jsm Channel Orchestrator",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "google.google-drive-rsl": {
      "resourceOwner": "google.google-drive-rsl",
      "displayName": "Google Drive",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "usage-tracking": {
      "resourceOwner": "usage-tracking",
      "displayName": "Usage Tracking",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-dc-secondary.jira-dc": {
      "resourceOwner": "jira-dc-secondary.jira-dc",
      "displayName": "Jira (Data Center)",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "jira-dc-tertiary.jira-dc": {
      "resourceOwner": "jira-dc-tertiary.jira-dc",
      "displayName": "Jira (Data Center)",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "datadog.datadog": {
      "resourceOwner": "datadog.datadog",
      "displayName": "Datadog",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "dynatrace.dynatrace": {
      "resourceOwner": "dynatrace.dynatrace",
      "displayName": "Dynatrace",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "studio": {
      "resourceOwner": "studio",
      "displayName": "Studio",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "cfo": {
      "resourceOwner": "cfo",
      "displayName": "Cfo",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "databricks.databricks": {
      "resourceOwner": "databricks.databricks",
      "displayName": "Databricks",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "google.google-drive-lite": {
      "resourceOwner": "google.google-drive-lite",
      "displayName": "Google Drive",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "graph-store": {
      "resourceOwner": "graph-store",
      "displayName": "Graph Store",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "customer-three-sixty": {
      "resourceOwner": "customer-three-sixty",
      "displayName": "Customer Three Sixty",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "newrelic.newrelic": {
      "resourceOwner": "newrelic.newrelic",
      "displayName": "New Relic",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "slack.slack-rsl": {
      "resourceOwner": "slack.slack-rsl",
      "displayName": "Slack",
      "isThirdParty": true,
      "platform": "third-party"
    },
    "navigation": {
      "resourceOwner": "navigation",
      "displayName": "Navigation",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "synthetic": {
      "resourceOwner": "synthetic",
      "displayName": "Synthetic",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "synthetic-a": {
      "resourceOwner": "synthetic-a",
      "displayName": "Synthetic A",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "blocks": {
      "resourceOwner": "blocks",
      "displayName": "Blocks",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "communication": {
      "resourceOwner": "communication",
      "displayName": "Communication",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "cpq": {
      "resourceOwner": "cpq",
      "displayName": "Cpq",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "org-config": {
      "resourceOwner": "org-config",
      "displayName": "Org Config",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "feedback": {
      "resourceOwner": "feedback",
      "displayName": "Feedback",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "governance-manager": {
      "resourceOwner": "governance-manager",
      "displayName": "Governance Manager",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "dx": {
      "resourceOwner": "dx",
      "displayName": "Developer Experience",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "growth-platform": {
      "resourceOwner": "growth-platform",
      "displayName": "Growth Platform",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "jira-product-discovery": {
      "resourceOwner": "jira-product-discovery",
      "displayName": "Jira Product Discovery",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "aiops": {
      "resourceOwner": "aiops",
      "displayName": "Aiops",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "customer-service-management": {
      "resourceOwner": "customer-service-management",
      "displayName": "Customer Service",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "cloud-transition": {
      "resourceOwner": "cloud-transition",
      "displayName": "Cloud Transition",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "secoda": {
      "resourceOwner": "secoda",
      "displayName": "Secoda",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "environment": {
      "resourceOwner": "environment",
      "displayName": "Environment",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "worklens": {
      "resourceOwner": "worklens",
      "displayName": "Work Lens",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "maui": {
      "resourceOwner": "maui",
      "displayName": "Maui",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "demo-three-sixty": {
      "resourceOwner": "demo-three-sixty",
      "displayName": "Demo Three Sixty",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "amp": {
      "resourceOwner": "amp",
      "displayName": "Amp",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "assets-vertical": {
      "resourceOwner": "assets-vertical",
      "displayName": "Assets Vertical",
      "isThirdParty": false,
      "platform": "cloud"
    },
    "cdm": {
      "resourceOwner": "cdm",
      "displayName": "Cdm",
      "isThirdParty": false,
      "platform": "cloud"
    }
  }
}
